<div class="container">

	<div class="col-12 col-md-8 offset-md-2  col-lg-6 offset-lg-3 p-4 mt-3 mb-4">
		<h3 class="mb-4 text-center">{{'Réinitialisation de votre mot de passe' | translate}}</h3>

		<div class="form-group">
			<label for="password">{{'Nouveau mot de passe' | translate}}:</label>
			<input [disabled]="loading" class="form-control form-control-danger" type="password" [(ngModel)]="password" name="password">
			<password-checker [password]="password" (changeValidity)="validPassword = $event"></password-checker>
		</div>
		<div class="form-group">
			<label for="password">{{'Confirmer le mot de passe' | translate}}:</label>
			<input [disabled]="loading" class="form-control form-control-danger" type="password" [(ngModel)]="password2" name="password">
			<span class="form-error text-danger" *ngIf="password2.length && password != password2">{{'Les mots de passe ne correspondent pas' | translate}}</span>
		</div>

		<button (click)="proceed()" [disabled]="loading || !validPassword || password != password2" class="btn btn-action btn-block">
			<i *ngIf="loading" class="fas fa-circle-notch fa-spin mr-1"></i>
			{{'Enregistrer' | translate}}
		</button>

	</div>
</div>
